import { Component, Inject, OnInit } from '@angular/core';
import { map, switchMap } from 'rxjs/operators';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-measure-report-consult',
  templateUrl: './modal-measure-report-consult.component.html',
  styleUrls: ['./modal-measure-report-consult.component.scss']
})
export class ModalMeasureReportConsultComponent implements OnInit {

  isLoading: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalMeasureReportConsultComponent>,
  ) { }

  ngOnInit(): void {
  }

  openConsult() {
    window.open('/activity/consult')
  }

  report() {
    const response = {
      status: true,
    }
    this.dialogRef.close(response);
  }

  closeModal() {
    const response = {
      status: false,
    }

    this.dialogRef.close(response);
    window.close();
  }

}

